import React, { useCallback, useState } from 'react';
import KeywordFilter from '../../../../../components/FiltersBar/KeywordFilter';
import { FilterRendererProps } from '../../GroupedTableRow/GroupedTableRow.types';

const StringFilterRenderer = <TData,>({ value, onFilter }: FilterRendererProps<TData, string>): React.ReactElement => {
  const [currentValue, setCurrentValue] = useState(value ? `${value}` : '');

  const handleClear = useCallback(() => {
    setCurrentValue('');
    onFilter('');
  }, [onFilter]);

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => setCurrentValue(e.currentTarget.value),
    [onFilter]
  );

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        onFilter(currentValue);
      } else if (e.key === 'Escape') {
        e.currentTarget.blur();
      }
    },
    [onFilter, currentValue]
  );

  return (
    <KeywordFilter
      value={currentValue}
      placeholder="Search"
      onClear={handleClear}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      fluid
    />
  );
};

export default StringFilterRenderer;
